import React from 'react'
import { Statistic } from 'semantic-ui-react'
import * as styles from './step_catch_text.module.sass' // eslint-disable-line no-restricted-imports

const StepCatchText = ({ children, stepText = undefined }) =>
  stepText ? (
    <Statistic horizontal className={styles.wrapper}>
      <Statistic.Value text>
        <span className={styles.step}>{stepText}</span>
      </Statistic.Value>
      <Statistic.Label as="h2">
        <p className={styles.text}>{children}</p>
      </Statistic.Label>
    </Statistic>
  ) : (
    <Statistic.Label as="h2">
      <p className={styles.text}>{children}</p>
    </Statistic.Label>
  )

export { StepCatchText }
